import React from "react";

const MicIcon = (props) => {
  return (
    props.isRecording ? 
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
    >
      <path
        d="M5.99935 10.1878C5.40213 10.1878 4.90213 9.97255 4.49935 9.54199C4.09657 9.11144 3.89518 8.5906 3.89518 7.97949V2.75033C3.89518 2.16699 4.10004 1.67394 4.50977 1.27116C4.91949 0.868381 5.41602 0.666992 5.99935 0.666992C6.58268 0.666992 7.07921 0.868381 7.48893 1.27116C7.89866 1.67394 8.10352 2.16699 8.10352 2.75033V7.97949C8.10352 8.5906 7.90213 9.11144 7.49935 9.54199C7.09657 9.97255 6.59657 10.1878 5.99935 10.1878ZM5.37435 16.5003V13.667C3.90213 13.5142 2.66602 12.8962 1.66602 11.8128C0.666016 10.7295 0.166016 9.45171 0.166016 7.97949H1.41602C1.41602 9.24338 1.86393 10.3059 2.75977 11.167C3.6556 12.0281 4.73546 12.4587 5.99935 12.4587C7.26324 12.4587 8.3431 12.0281 9.23893 11.167C10.1348 10.3059 10.5827 9.24338 10.5827 7.97949H11.8327C11.8327 9.45171 11.3327 10.7295 10.3327 11.8128C9.33268 12.8962 8.09657 13.5142 6.62435 13.667V16.5003H5.37435Z"
        fill="#A5A5A5"
      />
    </svg> 
    :
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
    >
      <path
        d="M5.99935 10.1878C5.40213 10.1878 4.90213 9.97255 4.49935 9.54199C4.09657 9.11144 3.89518 8.5906 3.89518 7.97949V2.75033C3.89518 2.16699 4.10004 1.67394 4.50977 1.27116C4.91949 0.868381 5.41602 0.666992 5.99935 0.666992C6.58268 0.666992 7.07921 0.868381 7.48893 1.27116C7.89866 1.67394 8.10352 2.16699 8.10352 2.75033V7.97949C8.10352 8.5906 7.90213 9.11144 7.49935 9.54199C7.09657 9.97255 6.59657 10.1878 5.99935 10.1878ZM5.37435 16.5003V13.667C3.90213 13.5142 2.66602 12.8962 1.66602 11.8128C0.666016 10.7295 0.166016 9.45171 0.166016 7.97949H1.41602C1.41602 9.24338 1.86393 10.3059 2.75977 11.167C3.6556 12.0281 4.73546 12.4587 5.99935 12.4587C7.26324 12.4587 8.3431 12.0281 9.23893 11.167C10.1348 10.3059 10.5827 9.24338 10.5827 7.97949H11.8327C11.8327 9.45171 11.3327 10.7295 10.3327 11.8128C9.33268 12.8962 8.09657 13.5142 6.62435 13.667V16.5003H5.37435Z"
        fill="#A5A5A5"
      />
      <line x1="0" y1="0" x2="12" y2="17" stroke="#A5A5A5" strokeWidth="1" />
    </svg>
  );
};

export default MicIcon;
